import { API_URL } from '../config/apiConfig'; // Use apiConfig for correct dev2 routing

export const API_CONFIG = {
  BASE_URL: API_URL,
  TIMEOUT: 60000,
};

export const PROMPT_ENHANCER_CONFIG = {
  BASE_URL:
    process.env.REACT_APP_PROMPT_ENHANCER_URL || 'https://enhance.genanything.ai',
  TIMEOUT: 120000, // Increased to 120s for mobile networks (was 60s)
  MAX_RETRIES: 3, // Retry up to 3 times on failure
  RETRY_DELAY: 2000, // Wait 2s between retries
};

export const POLLING = {
  VIDEO_STATUS: 3000, // Poll every 3 seconds
  MAX_RETRIES: 160, // 160 retries * 3 seconds = 8 minutes max
};

export const API_ENDPOINTS = {
  USER: {
    GET: '/api/user',
    UPDATE: '/api/user/credits',
    SIGNUP: '/api/user/signup',
    ANONYMOUS: '/api/users/anonymous',
    LINK_ANONYMOUS: '/api/users/link-anonymous',
  },
  VIDEOS: {
    LIST: '/videos',
    DELETE: '/videos',
    FAVORITE: '/videos/favorite',
  },
  GENERATE: {
    CREATE: '/generate',
    STATUS: '/generate/status',
    VIDEO: '/api/generate/video',
  },
  EXPORT: '/export',
  MODELS: '/models',
  TEMPLATES: '/templates',
  PAYMENT: {
    CREATE_CHECKOUT_SESSION: '/create-checkout-session',
  },
  UPLOAD: {
    IMAGE: '/api/upload/image',
  },
  PROMPT_ENHANCER: {
    ENHANCE_AND_GENERATE: '/api/enhance-from-supabase',
  },
  CREDITS: {
    BALANCE: '/api/user/credits/balance',
    HISTORY: '/api/user/credits/history',
  },
  STRIPE: {
    CREDIT_PACKS: '/api/stripe/credit-packs',
    CREATE_CREDIT_CHECKOUT: '/api/stripe/create-credit-checkout',
    CREDIT_CHECKOUT: '/api/stripe/credit-checkout',
    SUBSCRIPTION_PLANS: '/api/stripe/plans',
  },
};

// Credit costs for different operations
export const CREDIT_COSTS = {
  VIDEO_GENERATION: 100,
  IMAGE_GENERATION: 1,
  IMAGE_EDIT: 2,
  UPLOAD: 0,
  ENHANCEMENT: 0,
};

